// src/utils/tutorService.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

const functions = getFunctions(app);

export const saveTutorGoal = async (goal) => {
  const call = httpsCallable(functions, "saveTutorGoal");
  const result = await call({ goal });
  return result.data;
};

// messages: [{ role: "user" | "assistant", content: "..." }], newest last
export const sendTutorMessage = async (messages) => {
  const call = httpsCallable(functions, "tutorChat");
  const result = await call({ messages });
  return result.data; // { reply, daysLeft, remainingToday }
};